'use strict';

var _classCallCheck = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils = require("../utils");

var thorifyResult = function thorifyResult(result) {
  // tricks for compatible with original web3 instance
  // non-objects or non-arrays doesn't need isThorified property since thorify just overwritten 3 formatters
  // which all accept object as input
  if (utils.isArray(result)) {
    result = result.map(function (item) {
      Object.defineProperty(item, 'isThorified', {
        get: function get() {
          return true;
        }
      });
      return item;
    });
  } else if (utils.isObject(result)) {
    Object.defineProperty(result, 'isThorified', {
      get: function get() {
        return true;
      }
    });
  }

  return result;
};

var JSONRPC =
/*#__PURE__*/
function () {
  function JSONRPC(payload) {
    _classCallCheck(this, JSONRPC);

    this.id = payload.id;
    this.method = payload.method;
    this.params = payload.params;
  }

  _createClass(JSONRPC, [{
    key: "makeResult",
    value: function makeResult(result) {
      return {
        id: this.id,
        jsonrpc: '2.0',
        result: thorifyResult(result)
      };
    }
  }, {
    key: "makeError",
    value: function makeError(message) {
      return {
        id: this.id,
        jsonrpc: '2.0',
        error: {
          message: message
        }
      };
    }
  }, {
    key: "makeSubResult",
    value: function makeSubResult(result) {
      return {
        id: this.id,
        jsonrpc: '2.0',
        method: this.method,
        params: {
          result: {
            data: thorifyResult(result)
          },
          subscription: this.id
        }
      };
    }
  }, {
    key: "makeSubError",
    value: function makeSubError(error) {
      return {
        id: this.id,
        jsonrpc: '2.0',
        method: this.method,
        params: {
          result: {
            error: error
          },
          subscription: this.id
        }
      };
    }
  }]);

  return JSONRPC;
}();

exports.JSONRPC = JSONRPC;